import React from "react";
import "./Home2.css";
import img2 from "..//images/img2.jpg";

const Home2 = () => {
  return (
    <div className="home2">
      <h2>Come and discover the paragliding</h2>
         <h2>experience all over Lebanon:</h2>
      <div className="contents1">
        <div className="home2-content">
          <p>📍Jounieh, Faraya, Ehden, Miziara, Deddeh and Dannieh</p>

          <p>
            We offer paragliding flights all year long from January to December
          </p>

          <p>
            Tandem paragliding is highly safe comparable to hiking or running,
            and 15 times safer than driving.
          </p>
        </div>
            <img
                className="img1"
                src={img2}
                alt=""
            />
      </div>
    </div>
  );
};

export default Home2;
